import { productForDisplaySelector } from '../selectors';

const getStoreProductDetails = (state) => {
  const productInfo = productForDisplaySelector(state);
  const { local, national } = productInfo.storeInfo;
  return local || national;
};

export default getStoreProductDetails;
